import React from 'react';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { Link } from "react-router-dom";
import logoLight from "../../assets/images/Tren_taita_4.svg";
import { LoginForm } from "../../features/auth/components/LoginForm";

const Login = () => {
    document.title = "Login";

    return (
        <React.Fragment>
            <ParticlesAuth>
                <div className="auth-page-content mt-lg-5">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center mt-sm-5 mb-4 text-white-50">
                                    <div className="mt-4">
                                        <Link to="/" className="d-inline-block auth-logo">
                                            <img src={logoLight} alt="Tren Taita Logo" height="60" />
                                        </Link>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={5}>
                                <Card className="mt-4 card-bg-fill">
                                    <CardBody className="p-4">
                                        <div className="text-center mt-2 mb-4">
                                            <h5 className="text-primary">Bienvenido de nuevo</h5>
                                            <p className="text-muted">Inicia sesión</p>
                                        </div>
                                        
                                        <div className="p-2">
                                            <LoginForm />
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </ParticlesAuth>
        </React.Fragment>
    );
};

export default Login;
